
import React, { useState, useEffect } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import {
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CModal,
    CTabs,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge,
    CDataTable,
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CForm,
    CSelect,
    CFormGroup,
    CInputGroupAppend,
    CInputGroup,
    CLabel,
    CInputCheckbox,
    CSwitch,
    CFormText,
    CInput,
    CInputFile
} from '@coreui/react'
import { data } from 'jquery'

// import { config } from 'src/utils/apiUrl'
// import { API } from 'src/utils/apiCalling'
// import API from '../../utils/apiCalling';
// import { config } from '../../utils/apiUrl';

const ModalDocuments = (props) => {
    const { isOpen_Doc, isViewModalOpen_Doc, selectedViewDocument } = props
    // console.log(props,"jhbdfjhs")

    const [newConvertValue, setNewConvertValue] = useState([])
    const [isShowEducationDetails, setIsShowEducationDetails] = useState(false)

    useEffect(() => {
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>....document", selectedViewDocument)
        setNewConvertValue([])
        filterData()
    }, [selectedViewDocument])
    const filterData = () => {
        if (selectedViewDocument && !selectedViewDocument.data) {
            let newVal = Object.entries(selectedViewDocument)
            // console.log("****************", newVal)
            setNewConvertValue(newVal)
        }
    }

    return (
        <div className="">
            <CModal
                show={isOpen_Doc}
                onClose={() => isViewModalOpen_Doc()}
                size="lg"
            >
                <CModalHeader closeButton>
                    <CModalTitle>{selectedViewDocument && selectedViewDocument.tag_name + " View Document"}</CModalTitle>
                </CModalHeader>
                <CModalBody>

                    <CForm action="" encType="multipart/form-data" className="form-horizontal">
                        <CRow>
                            <CCol md="12">

                                {newConvertValue && newConvertValue.length > 0 && newConvertValue.map((details, index) => (
                                    <div className="card-header-form" style={{fontSize:"15px", fontWeight:"bolder"}}>
                                        <CFormGroup row>
                                        <div className="col-md-6">
                                            <CCol sm="12" md="12">
                                                
                                                <CLabel ><span className="text-capitalize">{details[0].replace(/[^a-zA-Z ]/g, " ")}</span></CLabel>
                                            </CCol>
         </div>
                                            <CCol sm="6" md="6">
                                                <CInput disabled value={details[1]} name="id" placeholder="" />
                                            </CCol>
                                        </CFormGroup>
                                        
                                    </div>
                                ))}

                                <>
                                    {selectedViewDocument && selectedViewDocument.tag_name == "Education Details" && selectedViewDocument.data.map((details, index) => (
                                        <div>
                                            <div className="card">
                                                <div className="card-header">
                                                    Details {index + 1}

                                                </div>
                                                <div className="card-header">

                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Educational Class</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_educational_class} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Roll No</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_roll_no} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Smp School</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_school} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Board</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_board} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Percentage</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_percentage} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Year</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.year} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Educational Class</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_educational_class} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>

                                <>
                                    {selectedViewDocument && selectedViewDocument.tag_name == "Document Details" && selectedViewDocument.data.map((details, index) => (
                                        <div>
                                            <div className="card">
                                                <div className="card-header" >
                                                    Details {index + 1}
                                                    {details.status == 1 &&
                                                        <i className="fa fa-check" aria-hidden="true"></i>
                                                    }
                                                </div>
                                                {/* class={details.status == 0 ? {color:"red"} : {color:""}} */}
                                                <div className="card-body" >
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Document Name</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.document_name} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel  ><span className="text-capitalize">Document Status</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput style={details.status == 0 ? { backgroundColor: "" } : { backgroundColor: "lightgreen" }} disabled value={details.status == 0 ? "Pending" : "Complete"} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>

                            </CCol>
                        </CRow>
                    </CForm>
                </CModalBody>
                <CModalFooter>
                    <CButton color="danger" onClick={() => isViewModalOpen_Doc(!isOpen_Doc)}><i className="fa fa-times" aria-hidden="true"></i>   </CButton>{' '}

                </CModalFooter>
            </CModal>

        </div>

    )
}
export default ModalDocuments








